import { __decorate } from "tslib";
import { __metadata } from "tslib";
import { Component, forwardRef, Input, EventEmitter, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
var CheckboxComponent = /*@__PURE__*/ (function () {
    /**
     * TypeScript public modifiers
     */
    function CheckboxComponent() {
        this.inputValue = '';
        this.onModelChange = new EventEmitter();
        /**
         * Set our default values
         */
        this.localState = { value: '' };
        this.active = false;
        // The internal data model
        this.innerValue = '';
    }
    CheckboxComponent_1 = CheckboxComponent;
    Object.defineProperty(CheckboxComponent.prototype, "value", {
        // get accessor
        get: function () {
            return this.innerValue;
        },
        // set accessor including call the onchange callback
        set: function (v) {
            this.innerValue = v;
            this.onChangeCallback(v);
        },
        enumerable: true,
        configurable: true
    });
    CheckboxComponent.prototype.clickEvent = function () {
        this.active = !this.active;
        this.writeValue(this.active ? this.inputValue : '');
        this.onChangeCallback(this.innerValue);
        if (this.onModelChange) {
            this.onModelChange.emit(this.inputValue);
        }
    };
    // From ControlValueAccessor interface
    CheckboxComponent.prototype.writeValue = function (value) {
        this.innerValue = value;
    };
    // From ControlValueAccessor interface
    CheckboxComponent.prototype.registerOnChange = function (fn) {
        this.onChangeCallback = fn;
    };
    // From ControlValueAccessor interface
    CheckboxComponent.prototype.registerOnTouched = function (fn) {
        this.onTouchedCallback = fn;
    };
    var CheckboxComponent_1;
    return CheckboxComponent;
}());
export { CheckboxComponent };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/app/shared/components/checkbox/checkbox.component.ts
// module id = null
// module chunks = 